import axios from 'axios'

const addItemToBox = (
  company: string,
  locationId: number,
  boxCode: string,
  itemCode: string
) =>
  axios.post(`/box/add-item-to-box`, { company, locationId, boxCode, itemCode })

const getOrCreateBox = (company: string, locationId: number, boxCode: string) =>
  axios.post('/box/get-or-create-box-by-code', { company, locationId, boxCode })

const getItemsInBox = (
  company: string,
  locationId: number,
  boxCode?: string,
  batchLabel?: string
) =>
  axios.get('/box/items-in-box', {
    params: {
      company,
      locationId,
      boxCode,
      ...(batchLabel ? { batchLabel } : {})
    }
  })

const clearAllBoxItems = (company: string) =>
  axios.delete('/box/all-box-items', {
    data: {
      company
    }
  })

const getAllBoxes = (company: string) =>
  axios.get('/box/all-boxes', {
    params: {
      company
    }
  })

const getBoxById = (boxId: string) =>
  axios.get(`/box/box-by-id`, { params: { boxId } })

const deleteBoxesById = (boxIds: string[]) =>
  axios.delete(`/box/boxes-by-id`, {
    data: {
      boxIds
    }
  })

const updateBoxItem = (boxItemId: string, quantity: number) =>
  axios.put(`/box/update-box-item`, {
    boxItemId,
    quantity
  })
const deleteBoxItem = (boxItemId: string) =>
  axios.delete(`/box/box-item`, {
    data: {
      boxItemId
    }
  })

export {
  addItemToBox,
  getOrCreateBox,
  getItemsInBox,
  clearAllBoxItems,
  getAllBoxes,
  getBoxById,
  deleteBoxesById,
  updateBoxItem,
  deleteBoxItem
}
